<lib-service-form>
  @if (showEntityTabs) {
    <div class="tabs-region" slot="tabs-slot" [class.overlay-active]="activeTab !== 'overview'">
      <div class="tab-nav" role="tablist">
        <a role="tab" class="tab" [routerLink]="['/services/advanced', entityId, 'overview']" [replaceUrl]="true" routerLinkActive="active">Overview</a>
        <a role="tab" class="tab" [routerLink]="['/services/advanced', entityId, 'metrics']" [replaceUrl]="true" routerLinkActive="active">Metrics</a>
        <a role="tab" class="tab" [routerLink]="['/services/advanced', entityId, 'dial-logs']" [replaceUrl]="true" routerLinkActive="active">Dial Logs</a>
      </div>
      @if (activeTab === 'metrics') {
        <div class="entity-tab-panel">
          <app-metrics-tab [data]="entityTabData"></app-metrics-tab>
        </div>
      }
      @if (activeTab === 'dial-logs') {
        <div class="entity-tab-panel dial-logs-panel">
          <app-dial-logs-timeline-tab [data]="entityTabData"></app-dial-logs-timeline-tab>
        </div>
      }
    </div>
  }
</lib-service-form>
